import React from 'react';
import styles from './CategoryList.module.css';

const CategoryList = () => (
  <div className={styles['category-list']}>Under construction</div>
);

export default CategoryList;
